export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"adopt-website-id","content":"bc30a1ea-bdca-4c2c-a0fb-f806bd71803b"}],"link":[{"rel":"preconnect","href":"https://www.facebook.com"},{"rel":"preconnect","href":"https://connect.facebook.net"},{"rel":"preconnect","href":"https://www.googletagmanager.com"},{"rel":"preconnect","href":"https://googleads.g.doubleclick.net"},{"rel":"preconnect","href":"https://www.google.com.br"},{"rel":"preload","href":"/fonts/Montserrat-VariableFont_wght.ttf","as":"font","crossorigin":"","type":"font/ttf"}],"style":[],"script":[{"src":"//tag.goadopt.io/injector.js?website_code=bc30a1ea-bdca-4c2c-a0fb-f806bd71803b","class":"adopt-injector","body":true,"async":true,"type":"text/javascript"},{"src":"https://d335luupugsy2.cloudfront.net/js/loader-scripts/713a1850-5f01-4100-b82b-54f0719d0ddf-loader.js","body":true,"async":true,"type":"text/javascript"},{"src":"https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js","type":"text/javascript","body":true}],"noscript":[],"htmlAttrs":{"lang":"pt-br"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000